import { render, staticRenderFns } from "./FittingsFlows.vue?vue&type=template&id=7dd74ed2&scoped=true"
import script from "./FittingsFlows.vue?vue&type=script&lang=js"
export * from "./FittingsFlows.vue?vue&type=script&lang=js"
import style0 from "./FittingsFlows.vue?vue&type=style&index=0&id=7dd74ed2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd74ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd74ed2')) {
      api.createRecord('7dd74ed2', component.options)
    } else {
      api.reload('7dd74ed2', component.options)
    }
    module.hot.accept("./FittingsFlows.vue?vue&type=template&id=7dd74ed2&scoped=true", function () {
      api.rerender('7dd74ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Fittings/FittingsFlows/FittingsFlows.vue"
export default component.exports